import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import {
  updateSelectedElementAction,
  fetchElementsInitAction,
  updateElementFiltersAction,
} from '../../../../../actions/instances/elements';
import BasePage from '../../../BasePage/BasePage';
import FullPageLoader from '../../../../atoms/FullPageLoader/FullPageLoader';
import EmptyView from '../../../../molecules/EmptyView/EmptyView';
import Icon from '../../../../atoms/Icon/Icon';
import DynastySelector from '../../../../atoms/DynastySelector/DynastySelector';
import CitySelector from '../../../../atoms/CitySelector/CItySelector';
import TagsSelector from '../../../../atoms/TagsSelector/TagsSelector';
import Sidebar from '../../../../molecules/Sidebar/Sidebar';
import ListBase from '../../../../Organisms/ListBase/ListBase';
import ListItem from '../../../../molecules/ListItem/ListItem';
import './ListComponents.scss';

const ListElements = () => {
  const {
    isLoadingElements,
    didLoadElements,
    elements,
    filters,
  } = useSelector(state => state.buildingElementInstance);
  const isFiltersDirty = filters.dynasties.length > 0
    || filters.cities.length > 0
    || filters.tags.length > 0;
  const dispatch = useDispatch();
  const history = useHistory();
  if (!didLoadElements && !isLoadingElements) {
    dispatch(fetchElementsInitAction());
  }
  if (isLoadingElements) {
    return <FullPageLoader />;
  }
  return (
    <BasePage>
      {
        elements.length === 0 && !isFiltersDirty
          ? (
            <EmptyView
              message="Looks like there's no building elements here yet."
              action={() => {
                history.push('/instances/building-elements/create');
              }}
            />
          ) : (
            <div className="components-page-content">
              <div className="actions-container">
                <h4 className="mb-4">Filter Elements</h4>
                <div className="filters">
                  <div className="actions">
                    <div className="filter-item">
                      <DynastySelector
                        isMulti
                        onChanged={(val) => {
                          filters.dynasties = val.map(dynasty => dynasty.value);
                          dispatch(updateElementFiltersAction(filters));
                        }}
                      />
                    </div>
                    <div className="filter-item">
                      <CitySelector
                        isMulti
                        onChanged={(val) => {
                          filters.cities = val.map(city => city.value);
                          dispatch(updateElementFiltersAction(filters));
                        }}
                      />
                    </div>
                    <div className="filter-item">
                      <TagsSelector
                        isMulti
                        onChanged={(val) => {
                          filters.tags = val.map(tag => tag.value);
                          dispatch(updateElementFiltersAction(filters));
                        }}
                      />
                    </div>
                  </div>
                  <Button variant="default" onClick={() => history.push('/instances/building-elements/create')}>
                    <Icon icon="plus" color="#000" />
                  </Button>
                </div>
              </div>
              <div className="row components-list">
                <div className="col-md-9">
                  {elements && elements.length > 0 ? (
                    <ListBase>
                      {elements.map(element => (
                        <ListItem
                          imgSrc={element.images.length > 0 ? element.images[0].url : '/images/default.png'}
                          name={element.name}
                          code={element.code}
                          dynasty={element.dynasty.name}
                          location={`${element.city.name} [${element.city.country.code}-${element.city.code}]`}
                          creationDate={element.created_at}
                          onViewClicked={() => {
                            dispatch(updateSelectedElementAction(element));
                            history.push('/instances/building-elements/view');
                          }}
                          onEditClicked={() => {
                            dispatch(updateSelectedElementAction(element));
                            history.push('/instances/building-elements/edit');
                          }}
                          inReview={element.in_review}
                        />
                      ))}
                    </ListBase>
                  ) : (
                    <EmptyView
                      message="No elements matches these filters"
                      action={() => history.push('/instances/building-elements/create')}
                    />
                  )}
                </div>
                <div className="col-md-3 p-0">
                  <Sidebar />
                </div>
              </div>
            </div>
          )
      }
    </BasePage>
  );
};

export default ListElements;
